import { forwardRef, useEffect, useRef } from "react";
import { useFormContext, Controller } from "react-hook-form";
import { useParams } from "react-router-dom";
import { MDBRow, MDBCol } from "mdbreact";

import "./E2DataFlowActivitiesProcedure.scss"

import { Button, Label, TextArea } from "abs-ui-components";

import { AUTOSAVE_SUCCESS_MESSAGE, cSectionFormFields } from "../../Constants";
import { callApi } from "../../../../../services/MonitoringPlanService";
import { API_ROUTES } from "../../ApiRoutes/ApiRoutes";
import { emitToasterMsg } from "../../../../../services/toasterUtility";
import AutoSave from "../../../../../common/AutoSave/AutoSave";

const E2DataFlowActivitiesProcedure = forwardRef(({ e2DataFlowProcedures,vesselMstId, refetchMonitoringData }, ref) => {
    const { control, getValues, reset, formState } = useFormContext();
    const { isDirty } = formState;
    const lastManualSave = useRef(null);
    const manualSaveTriggered = useRef(false);

    useEffect(() => {
        if (e2DataFlowProcedures) {
            reset(prev => ({ ...prev, e2: e2DataFlowProcedures }));
        }
    }, [e2DataFlowProcedures, reset]);

    AutoSave(ref, [], async () => {
        if (!isDirty) return;
        await handleSave(true);
    });

    const handleSave = async (isAuto = false) => {
        const formValues = getValues("e2");
        const payload = {
            ...filteredFields.reduce((acc, { name }) => {
                acc[name] = formValues?.[name] || "";
                return acc;
            }, {}),
        };
        try {
            const e2DataFlowActivitiesProcedure = await callApi({
                method: "POST",
                url: API_ROUTES.E2(vesselMstId),
                data: payload,
            });
            if (e2DataFlowActivitiesProcedure?.isSuccess) {
                emitToasterMsg("success", "Table E.2", isAuto ? AUTOSAVE_SUCCESS_MESSAGE : "Created successfully");
                reset(prev => ({ ...prev, e2: formValues }));
                if (!isAuto) {
                    lastManualSave.current = Date.now();
                }
                if (typeof refetchMonitoringData === "function") {
                    await refetchMonitoringData();
                }
            }
            else {
                emitToasterMsg("error", "Table E.2", e2DataFlowActivitiesProcedure?.errorMessage);
            }
        } catch (error) {
            emitToasterMsg("error", "Table E.2", error?.errorMessage);
        }
    };

    const filteredFields = cSectionFormFields.filter(
        (field) => field.name !== "versionOfProcedure" && field.name !== "formulaeAndDataSources")
        .map(field => {
            if (field.name === "referenceToProcedure") {
                return {
                    ...field,
                    label: "Reference for procedure",
                };
            }
            return field;
        });

    return (
        <div className="e2-section-form mt-4">
            <MDBRow className="mb-2">
                <MDBCol md="4">
                    <h6 className="titles-font">Title of procedure</h6>
                </MDBCol>
                <MDBCol md="4">
                    <h6 className="titles-font">Procedures for data flow activities</h6>
                </MDBCol>
            </MDBRow>

            {filteredFields.map(({ label, name, maxLength }, index) => (
                <MDBRow className="align-items-center mb-3" key={index}>
                    <MDBCol md="4">
                        <Label name={label} bold />
                    </MDBCol>
                    <MDBCol md="4">
                        <Controller
                            name={`e2.${name}`}
                            control={control}
                            render={({ field }) => (
                                <TextArea
                                    id={`e2_${name}`}
                                    className="textarea-resize"
                                    value={field?.value || ""}
                                    onChange={field.onChange}
                                    placeholder=""
                                    maxLength={maxLength}
                                    rows={1}
                                />
                            )}
                        />
                    </MDBCol>
                </MDBRow>
            ))}

            <div className="text-center">
                <Button id="e2_save_btn"
                    onClick={async () => {
                        manualSaveTriggered.current = true;
                        await handleSave(false);
                    }}
                    disabled={!isDirty}
                >Save</Button>
            </div>
        </div>
    );
});

export default E2DataFlowActivitiesProcedure;